import React from 'react';
type CheckboxFieldProps = {
  name: string;
  label: React.ReactNode;
  required?: boolean;
};
export function CheckboxField({
  name,
  label,
  required
}: CheckboxFieldProps) {
  const id = `field-${name}`;
  return <label htmlFor={id} className="flex cursor-pointer items-start gap-3 py-2" data-id="element-51" data-mp="ypgaxfmlnoro">
      <input id={id} name={name} type="checkbox" required={required} className="mt-1 h-4 w-4 shrink-0 cursor-pointer appearance-none border border-ink-line bg-ink-surface checked:border-white checked:bg-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-52" data-mp="12p8jvtfwnwxk" />
      <span className="text-sm leading-relaxed text-ink-muted" data-id="element-53" data-mp="1hh8zmxumyntl">
        {label}
        {required && <span data-id="element-54" data-mp="1mg3qmn2rbios"> *</span>}
      </span>
    </label>;
}